import { makeStyles } from '@material-ui/core/styles';
import { COLORS } from '../../styles/constants';

export const usePaperStyles = makeStyles(theme => ({
	root: {
		flexGrow: props => (props.flexGrow ? 1 : 0),
		padding: props =>
			props.padding
				? Array.isArray(props.padding) && props.padding.length === 2
					? `${theme.spacing(props.padding[0])}px
                   ${theme.spacing(props.padding[1])}px`
					: Array.isArray(props.padding) && props.padding.length === 4
					? `${theme.spacing(props.padding[0])}px
                   ${theme.spacing(props.padding[1])}px
                   ${theme.spacing(props.padding[2])}px
                   ${theme.spacing(props.padding[3])}px`
					: theme.spacing(props.padding)
				: 0,
		backgroundColor: props => (props.grey ? COLORS.BACKGROUND : theme.palette.common.white),
		border: props => (props.noBorder ? 0 : `1px solid ${COLORS.BORDER}`)
	}
}));
